import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/Badge";
import { Icon } from "@/components/Icon";
import { useToast } from "@/context/ToastContext";

export const DatabaseSync: React.FC = () => {
    const { t } = useTranslation("global");
    const { showError } = useToast();

    return (
        <div
            onClick={() => showError(t("tools.database_sync.development_notice"))}
            className="group flex cursor-pointer flex-col items-center justify-center rounded-xl border border-gray-200 bg-white p-6 shadow-sm transition-all hover:border-primary/50 hover:shadow-md dark:border-white/10 dark:bg-dark-card"
        >
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg transition-transform group-hover:scale-110">
                <Icon value="database" size={24} color="primary" background />
            </div>
            <div className="text-center text-sm font-medium text-gray-900 dark:text-white">
                {t("tools.database_sync.title")}
            </div>
            <div className="mt-1 line-clamp-2 text-center text-xs text-gray-500 dark:text-zinc-400">
                {t("tools.database_sync.description")}
            </div>
            <div className="mt-3">
                <Badge variant="warning" pill={false}>
                    {t("tools.database_sync.badge")}
                </Badge>
            </div>
        </div>
    );
};
